import React, { useState, useRef, useEffect } from "react";
import CTAButtons from "../ReuasbleComponets/CTAButtons";
import Blog_Lead from "./Blog_leadmagnet";
import FloatingWidget from "./FloatingWidget";
import MyCardGrid from "./CardGrid";
import ZohoChatPopup from "../ReuasbleComponets/Chatpopup";
import { Outlet, useNavigate, useParams, useLocation } from "react-router-dom"; // added useLocation
import {
  getMainBlogPost,
  fetchArticlesFromWordpress,
} from "../../Services/Actions/WordpressApi";
import NxaFAQBlog from "./NxaFaqBlog";
import SearchDropdown from "./BlogSearch";

const tabs = [
  { label: "All", slug: "all" },
  { label: "Start-ups", slug: "start-ups" },
  { label: "Remote & Hybrid work", slug: "remote-hybrid-work" },
  { label: "Sales & Support", slug: "sales-support" },
  { label: "Product Updates", slug: "product-updates" },
  { label: "Customer stories", slug: "customer-stories" },
  { label: "Ms Teams & Intergrations", slug: "ms-teams-integrations" },
  { label: "AI & Trends", slug: "ai-trends" },
  { label: "Security", slug: "security" },
  { label: "Smart City", slug: "smart-city" },
];

const Blog = () => {
  const [activeTab, setActiveTab] = useState(0);
  const params = useParams();
  const location = useLocation(); // added line
  const tabRefs = useRef([]);
  const [indicatorStyle, setIndicatorStyle] = useState({ width: 0, left: 0 });
  const [mainPost, setMainPost] = useState(null);
  const [articles, setArticles] = useState([]);
  const navigate = useNavigate();
  console.log(params);

  useEffect(() => {
    const currentTab = tabRefs.current[activeTab];
    if (currentTab) {
      setIndicatorStyle({
        width: currentTab.offsetWidth,
        left: currentTab.offsetLeft,
      });
    }
  }, [activeTab]);

  useEffect(() => {
    const fetchMainPost = async () => {
      const post = await getMainBlogPost();
      if (post) setMainPost(post);
    };
    fetchMainPost();
  }, []);

  useEffect(() => {
    const fetchAllArticles = async () => {
      try {
        const fetchedArticles = await fetchArticlesFromWordpress();
        setArticles(fetchedArticles);
      } catch (err) {
        console.error("Failed to fetch articles:", err);
      }
    };
    fetchAllArticles();
  }, []);

  // updated active tab logic to handle both /blog/:slug and /blog?slug=
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const searchSlug = searchParams.get("slug");

    // *** Minimal change here: default to "all" if no slug or path is "/blog" ***
    let slugToCheck = params.slug || searchSlug;

    // Added check for undefined slug to show all articles when navigating back
    if (
      !slugToCheck ||
      slugToCheck === "undefined" ||
      location.pathname === "/blog"
    ) {
      slugToCheck = "all";
      navigate("/blog/all", { replace: true }); // optional: update URL to keep in sync
    }

    const foundIndex = tabs.findIndex((tab) => tab.slug === slugToCheck);
    setActiveTab(foundIndex !== -1 ? foundIndex : 0);
  }, [params.slug, location.search, location.pathname]);

  const handleReadMore = () => {
    if (mainPost && mainPost.slug) {
      navigate(`/blog-details/${mainPost.slug}`);
    }
  };

  const activeTabObj = tabs[activeTab];
  const filterSlug = activeTabObj.slug;

  return (
    <>
      <FloatingWidget />
      <ZohoChatPopup />
      <div className="tab-nav">
        <div className="tab-nav__wrapper">
          <div className="tab-nav__list">
            {tabs.map((tabObj, index) => (
              <button
                key={index}
                ref={(el) => (tabRefs.current[index] = el)}
                className={`tab-nav__item ${
                  activeTab === index ? "tab-nav__item--active" : ""
                }`}
                onClick={() => {
                  setActiveTab(index);
                  navigate(`/blog/${tabObj.slug}`);
                }}
              >
                {tabObj.label}
              </button>
            ))}
            <span
              className="tab-nav__indicator"
              style={{
                width: `${indicatorStyle.width}px`,
                left: `${indicatorStyle.left}px`,
              }}
            />
          </div>

          <div className="tab-nav__search">
            <SearchDropdown />
          </div>
        </div>
      </div>

      <section className="blog-hero">
        <div className="blog-hero__image">
          <img
            className="blog-main"
            src="./../assets/images/Blog/LadyonCall.webp"
            alt="Lady on a Call"
            loading="lazy"
          />
        </div>
        <div className="blog-hero__content">
          <h1>
            The Smart <span>Communication</span> Platform For Businesses
          </h1>
          <p>Call, meet, and share files effortlessly All-In-One platform.</p>
          <div className="blog-hero__button">
            <a
              href="/signup"
              className="btn bg--orange text--white border--2 border--orange sf--t-medium radius--7"
            >
              Explore Now
            </a>
          </div>
        </div>
      </section>
      {mainPost && (
        <section className="Blog-article-leadmagent">
          <div className="Blog-article-leadmagent__content">
            <h1>{mainPost.title}</h1>
            <div className="Blog-article-leadmagent__publishdate">
              <img
                className="Blog-article-leadmagent__profile"
                src="../assets/images/Blog/avataricon.svg"
                alt="User Profile Image"
                loading="lazy"
              />
              <p>
                {mainPost.author} on {mainPost.date}
              </p>
            </div>
            <div
              className="Blog-article-leadmagent__Read-Button"
              onClick={handleReadMore}
            >
              Read More
            </div>
          </div>
          <div className="Blog-article-leadmagent__lead">
            <Blog_Lead />
          </div>
        </section>
      )}

      <Outlet />
      <section className="blog-faq">
        <NxaFAQBlog />
      </section>
      <section className="blog-start-free">
        <div className="blog-start-image">
          <img
            className="blog-free"
            src="./../assets/images/Blog/tryfree.webp"
            alt="Lady Taking a Call"
            loading="lazy"
          />
        </div>
        <div className="blog-free__content">
          <h1>Try Nxatel for free for 14 Days</h1>
          <p>Nxatel runs on the device you're using right now.​</p>
          <p>Ready to switch to a unified platform?​</p>
          <div className="blog-button">
            <CTAButtons />
          </div>
        </div>
      </section>
    </>
  );
};

export default Blog;
